'use client';

import { Button } from '@packages/shared/src/ui/Button/Button';
import { useLoyaltyApi } from '@packages/shared/src/hooks/useLoyaltyApi/useLoyaltyApi';
import { useIntl } from 'react-intl';
import useSWRMutation from 'swr/mutation';
import { useSWRConfig } from 'swr';
import { usePaybackClient } from '@packages/modules/src/Payback/usePaybackClient';
import { buttonMessages } from '../Payback/messages';

export const DeleteLoyaltyConnectionButton = () => {
  const { formatMessage, locale } = useIntl();
  const { mutate } = useSWRConfig();
  const context = usePaybackClient();
  if (!context) {
    throw new Error('usePaybackClient must be used within PaybackClientProvider');
  }
  const { closeDialogHandler } = context;
  const loyaltyApi = useLoyaltyApi();
  const { trigger } = useSWRMutation(
    'deleteLoyaltyConnection',
    () => loyaltyApi?.deleteLoyaltyConnection({ ecLocale: locale }),
    // important to force a revalidation
    {
      onSuccess: () => {
        mutate('getLoyaltyConnectionStatus');
        closeDialogHandler();
      },
    },
  );
  const handleDeleteLoyaltyConnection = async () => {
    await trigger();
  };
  return (
    <Button onClick={handleDeleteLoyaltyConnection} color="primary">
      {formatMessage(buttonMessages.DialogDeclineButton)}
    </Button>
  );
};
